import React, { Suspense } from 'react';
import { useState, useRef } from 'react';
import './App.css';
import Hero from './Components/jsx/Hero';

// Lazy load components for performance optimization
const Projects = React.lazy(() => import('./Components/jsx/Projects'));
const Contact = React.lazy(() => import('./Components/jsx/Contact'));
const About = React.lazy(() => import('./Components/jsx/About'));
const Footer = React.lazy(() => import('./Components/jsx/Footer'));
const ScrollToTop = React.lazy(() => import('./Components/jsx/ScrollToTop'));
const Experience = React.lazy(() => import('./Components/jsx/Experience'));

const App = () => {
    const projectRef = useRef(null);
    const experienceRef = useRef(null);
    const aboutRef = useRef(null);
    const contactRef = useRef(null);
    return (
        <Suspense fallback={<div style={{ height: '100vh', width: '100%', background: '#0b1d26' }}></div>}>
            <ScrollToTop />
            <Hero projectRef={projectRef} experienceRef={experienceRef} aboutRef={aboutRef} contactRef={contactRef} />
            <Experience ref={experienceRef} />
            <Projects ref={projectRef} />
            <Contact ref={contactRef} />
            <About ref={aboutRef} />
            <Footer />
        </Suspense>
    )
}

export default App
